module.exports = __webpack_public_path__ + "static/img/三星Galaxy Ring.0b27382f.png";